export const DEPRECIATION = {
  initial_used_factor: 0.85,
  age: {
    phase1_years: 10,
    phase1_power: 0.50,
    transition_value_eur: 200,
    phase2_end_years: 15,
    phase2_power: 1.5,
    floor_value_eur: 50,
  },
  jumps: {
    horizon_jumps: 1200,
    power: 0.60,
    estimate_cap: 800,
    estimate_tau: 6,
  },
  combination: {
    secondary_weight: 0.25,
  },
};

export const ADJUSTMENTS = {
  version_penalty: {
    'freak-2':     0.40,
    'freak-3':     0.50,
    'freak-4':     0.62,
    'freak-5':     0.80,
    'creature':    0.78,
    'colugo':      0.75,
    'aura':        0.40,
    'aura-2':      0.50,
    'aura-3':      0.60,
    'aura-4':      0.70,
    'aura-5':      0.82,
    'corvid':      0.55,
    'corvid-2':    0.72,
    'c-race':      0.82,
    'atc':         0.40,
    'atc-2':       0.50,
    'atc-3':       0.62,
    'atc-4':       0.76,
    'swift':       0.40,
    'swift-2':     0.50,
    'swift-3':     0.62,
    'swift-4':     0.78,
    'low-ki':      0.78,
    'shadow':      0.80,
    'phantom':     0.68,
    'phantom-2':   0.78,
    'phantom-3':   0.88,
    'strix':       0.85,
    'havok':       0.75,
    'havok-carve': 0.82,
    'x-bird':      0.45,
    'x2':          0.62,
    'piranha':     0.40,
    'piranha-2':   0.50,
    'piranha-3':   0.62,
    'piranha-4':   0.76,
    'barracuda':   0.40,
    'barracuda-2': 0.50,
    'barracuda-3': 0.62,
    'barracuda-4': 0.76,
    _default:      1.0,
  },
  brand_attractiveness: {
    'squirrel':    1.05,
    'phoenix-fly': 1.02,
    'tonysuits':   1.0,
    'intrudair':   0.98,
    _default_manufacturer: 1.0,
    _unknown_manufacturer: 0.95,
  },
  sizing: {
    tiers: [
      { height_above: 195, penalty: 0.92, label: 'very tall (>195cm)' },
      { height_below: 160, penalty: 0.92, label: 'very short (<160cm)' },
    ],
    _default: 1.0,
  },
  condition: {
    'condition-like-new': 1.10,
    'condition-good':     1.0,
    'condition-fair':     0.85,
    'condition-poor':     0.65,
    _default:             1.0,
  },
  base_use: {
    penalty: 0.95,
  },
};

export const MANUFACTURERS = {
  squirrel: {
    brand_key: 'squirrel',
    models: {
      'sprint':      { new_price_eur: 861 },
      'swift-5':     { new_price_eur: 1470 },
      'low-ki-2':    { new_price_eur: 1610 },
      'atc-5':       { new_price_eur: 1697 },
      'freak-6':     { new_price_eur: 1818 },
      'creature-2':  { new_price_eur: 1892 },
      'corvid-3':    { new_price_eur: 1958 },
      'aura-6':      { new_price_eur: 1958 },
      'c-race':      { new_price_eur: 1958 },
      'cr+':         { new_price_eur: 2088 },
      'c-base':      { new_price_eur: 1910 },
      'freak-5':     { new_price_eur: 1818 },
      'freak-4':     { new_price_eur: 1818 },
      'freak-3':     { new_price_eur: 1818 },
      'freak-2':     { new_price_eur: 1818 },
      'creature':    { new_price_eur: 1892 },
      'colugo-2':    { new_price_eur: 1470 },
      'colugo':      { new_price_eur: 1470 },
      'aura-5':      { new_price_eur: 1958 },
      'aura-4':      { new_price_eur: 1958 },
      'aura-3':      { new_price_eur: 1958 },
      'aura-2':      { new_price_eur: 1958 },
      'aura':        { new_price_eur: 1958 },
      'corvid-2':    { new_price_eur: 1958 },
      'corvid':      { new_price_eur: 1958 },
      'atc-4':       { new_price_eur: 1697 },
      'atc-3':       { new_price_eur: 1697 },
      'atc-2':       { new_price_eur: 1697 },
      'atc':         { new_price_eur: 1697 },
      'swift-4':     { new_price_eur: 1470 },
      'swift-3':     { new_price_eur: 1470 },
      'swift-2':     { new_price_eur: 1470 },
      'swift':       { new_price_eur: 1470 },
      'low-ki':      { new_price_eur: 1610 },
    },
  },
  'phoenix-fly': {
    brand_key: 'phoenix-fly',
    models: {
      'shadow':     { new_price_eur: 1214 },
      'phantom':    { new_price_eur: 1357 },
      'strix':      { new_price_eur: 1575 },
      'omni':       { new_price_eur: 1618 },
      'meru':       { new_price_eur: 1644 },
      'havok':      { new_price_eur: 1527 },
      'roc':        { new_price_eur: 1710 },
      'cima':       { new_price_eur: 1710 },
      'vampire':    { new_price_eur: 1884 },
      'vampire-competition': { new_price_eur: 1927 },
      'phantom-2':  { new_price_eur: 1357 },
      'phantom-3':  { new_price_eur: 1357 },
      'havok-carve': { new_price_eur: 1527 },
      'shadow-2':   { new_price_eur: 1214 },
    },
  },
  tonysuits: {
    brand_key: 'tonysuits',
    models: {
      'r3':         { new_price_eur: 1305 },
      'colibri':    { new_price_eur: 1086 },
      'ti-bird-2':  { new_price_eur: 1022 },
      'piper':      { new_price_eur: 1297 },
      'raven':      { new_price_eur: 1369 },
      'foghead-4':  { new_price_eur: 1543 },
      'jnite':      { new_price_eur: 1721 },
      'jedei':      { new_price_eur: 2018 },
      'nimbus-ls1': { new_price_eur: 1644 },
      'x2':         { new_price_eur: 1305 },
      'x-bird':     { new_price_eur: 1305 },
    },
  },
  intrudair: {
    brand_key: 'intrudair',
    models: {
      'piranha-5':   { new_price_eur: 1250 },
      'fin':         { new_price_eur: 1300 },
      'barracuda-5': { new_price_eur: 1350 },
      'pike':        { new_price_eur: 1550 },
      'mako-2':      { new_price_eur: 1750 },
      'manta':       { new_price_eur: 1750 },
      'ray':         { new_price_eur: 1750 },
      'piranha-4':   { new_price_eur: 1250 },
      'piranha-3':   { new_price_eur: 1250 },
      'piranha-2':   { new_price_eur: 1250 },
      'piranha':     { new_price_eur: 1250 },
      'barracuda-4': { new_price_eur: 1350 },
      'barracuda-3': { new_price_eur: 1350 },
      'barracuda-2': { new_price_eur: 1350 },
      'barracuda':   { new_price_eur: 1350 },
    },
  },
};
